<template>
  <v-layout>
    <v-container grid-list-md>
      <v-card>
        <v-card-title class="greyk lighten-4k">
          <h3>My Wards</h3>
        </v-card-title>

        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm12>
              <v-data-table
                :headers="students_headers"
                :items="myWards"
                student="elevation-0"
                :search="search"
                :loading="gwloading"
              >
                <template v-slot:items="props">
                  <td>{{ props.index + 1 }}</td>
                  <td>
                    <img
                      :src="props.item.avatar"
                      alt="profile pic"
                      student="mt-2"
                      style="width:50px;height:50px;border-radius:50%"
                      v-if="props.item.avatar"
                    />
                    <img
                      src="../../../../img/user.jpg"
                      alt="profile pic"
                      student="mt-2"
                      style="width:50px;height:50px;border-radius:50%"
                      v-else
                    />
                  </td>
                  <td student="text-xs-center">{{ props.item.s_bio.name }}</td>
                  <td student="text-xs-center">{{ props.item.rollno }}</td>
                  <td student="text-xs-center">{{ props.item.s_bio.email }}</td>
                  <td student="text-xs-center">{{ props.item.s_class.name}}</td>

                  <td student="text-xs-center">
                    <v-layout row wrap>
                      <v-flex xs6 sm3>
                        <v-tooltip bottom>
                          <template v-slot:activator="{on}">
                            <v-btn flat icon color="yellow" @click="showPerf(props.item)" v-on="on">
                              <v-icon>bar_chart</v-icon>
                            </v-btn>
                          </template>
                          <span>View {{props.item.s_bio.name+"'s"}} academic performance</span>
                        </v-tooltip>
                      </v-flex>

                      <!-- <v-flex xs6 sm3>
                        <v-btn flat icon color="blue" @click="showRpt(props.item)">
                          <v-icon>list</v-icon>
                        </v-btn>
                      </v-flex>-->

                      <v-flex xs6 sm3>
                        <v-tooltip bottom>
                          <template v-slot:activator="{on}">
                            <v-btn
                              flat
                              icon
                              color="pink"
                              @click="showFeeSummary(props.item)"
                              v-on="on"
                            >
                              <v-icon>money</v-icon>
                            </v-btn>
                          </template>
                          <span>View {{props.item.s_bio.name+"'s"}} fees summary</span>
                        </v-tooltip>
                      </v-flex>
                    </v-layout>
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-card-text>

        <!-- student performance dialog -->
        <pdlog pers title="Student Performance" :show="showP">
          <template v-slot:header-actions>
            <v-autocomplete
              label="Academic Year"
              :items="acyears"
              item-text="year"
              item-value="id"
              v-model="pr_acyear_id"
            ></v-autocomplete>
            <v-btn @click="showP=!showP" icon style="cursor:pointer">
              <v-icon>close</v-icon>
            </v-btn>
          </template>
          <template v-slot:content>
            <div>
              <s-perf :student_details="selected_ward" :acyear="pr_acyear_id"></s-perf>
            </div>
          </template>

          <template v-slot:footer-actions>
            <v-btn style="cursor:pointer" color="success" icon @click="printPerfStats('perf')">
              <v-icon>print</v-icon>
            </v-btn>
          </template>
        </pdlog>

        <pdlog pers title="Ward Fee Summary" :show="showFS">
          <template v-slot:header-actions>
            <v-btn icon @click="showFS=!showFS" style="cursor:pointer">
              <v-icon>close</v-icon>
            </v-btn>
          </template>
          <template v-slot:content>
            <div>
              <fee-summary :student_details="selected_ward"></fee-summary>
            </div>
          </template>

          <template v-slot:footer-actions>
            <!-- <v-btn style="cursor:pointer" color="error" @click="showFS=!showFS">close</v-btn> -->
          </template>
        </pdlog>
      </v-card>
    </v-container>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import pdlog from "../../../components/Modal";
import SPerformance from "../../../components/student/performanceStats";
import FSumry from "../../../components/student/feeSummary";
export default {
  layout: "guardian",
  components: {
    pdlog: pdlog,
    "s-perf": SPerformance,
    "fee-summary": FSumry
  },
  data() {
    return {
      showP: false,
      showR: false,
      showB: false,
      showFS: false,
      selected_ward: {
        rollno: "",
        s_bio: {
          name: ""
        },
        s_class: {
          name: ""
        },
        s_guardian: {
          name: ""
        }
      },
      pr_acyear_id: 0,
      search: "",
      students_headers: [
        {
          text: "SN",
          align: "center",
          sortable: false,
          value: "level"
        },
        {
          text: "Image",
          align: "center",
          sortable: false,
          value: "student"
        },
        {
          text: "Name",
          align: "center",
          sortable: true,
          value: "name"
        },
         {
          text: "Roll. No.",
          align: "center",
          sortable: true,
          value: "rollno"
        },
        {
          text: "Email",
          align: "center",
          sortable: true,
          value: "email"
        },

        {
          text: "Class",
          align: "center",
          sortable: false,
          value: "s_class.name"
        },
        {
          text: "Actions",
          align: "center",
          sortable: false,
          value: "s_guardian.phone"
        }
      ]
    };
  },
  mounted() {
    this.$store.dispatch("guardians/myWards");
    this.$store.dispatch("academicYear/getAll");
  },
  computed: {
    ...mapGetters({
      myWards: "guardians/GUARDIAN_WARDS",
      gwloading: "guardians/GUARDIAN_LOADING",
      gerrors: "guardians/GUARDIAN_ERROR",

      acyears: "academicYear/ACYEARS",
      errors: "academicYear/ACYEAR_ERROR",
      acloading: "academicYear/ACYEAR_LOADING"
    })
  },
  methods: {
    showPerf(std) {
      //this.pr_acyear_id = 0;
      this.selected_ward = std;
      this.showP = !this.showP;
    },

    showRpt(std) {
      this.selected_ward = std;
      this.showR = !this.showR;
    },

    showFeeSummary(std) {
      this.selected_ward = std;
      this.showFS = !this.showFS;
    },

    printPerfStats(doc) {
      //different print method because it has charts in it

      //console.log(prtHtml)

      let lc_canvas = document.getElementById("line-chart");
      let bc_canvas = document.getElementById("bar-chart");
      if (lc_canvas.outerHTML || bc_canvas.outerHTML) {
        let lc_img =
          "<img src='" +
          lc_canvas.toDataURL() +
          "' style='height: 100%; width: 100%; object-fit: contain'/>";
        let bc_img =
          "<img src='" +
          bc_canvas.toDataURL() +
          "' style='height: 100%; width: 100%; object-fit: contain'/>";

        lc_canvas.outerHTML = lc_img;
        bc_canvas.outerHTML = bc_img;
      }

      // Get HTML to print from element
      const prtHtml = document.getElementById(doc).innerHTML;

      this.showP = !this.showP;

      // Get all stylesheets HTML
      let stylesHtml = "";
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style')
      ]) {
        stylesHtml += node.outerHTML;
      }

      var toPrint = `<!DOCTYPE html>
<html>
  <head>
    ${stylesHtml}
  </head>
  <body>
    ${prtHtml}
  </body>
</html>`;

      // Open the print window
      const WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
      );

      WinPrint.document.write(toPrint);

      WinPrint.document.close();
      WinPrint.focus();

      if (WinPrint.document.readyState === "complete") {
        setTimeout(function() {
          WinPrint.print();
          WinPrint.close();
        }, 1300);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/guardian/wards/wards.vue